// A small CSV reader for the lead import: quoted cells, doubled quotes, newlines
// inside quotes, CRLF, a UTF-8 BOM, and a comma, semicolon or tab between cells.
// Blank lines are dropped. Rows are padded or cut to the header's width.

export interface Csv {
  headers: string[]
  rows: string[][]
}

function delimiterOf(firstLine: string): string {
  if (firstLine.includes(',')) return ','
  if (firstLine.includes(';')) return ';'
  return firstLine.includes('\t') ? '\t' : ','
}

export function parseCsv(input: string): Csv {
  const text = input.charCodeAt(0) === 0xfeff ? input.slice(1) : input
  const delimiter = delimiterOf(text.slice(0, text.search(/\r?\n|$/)))
  const records: string[][] = []
  let row: string[] = []
  let cell = ''
  let quoted = false

  const endCell = () => {
    row.push(cell)
    cell = ''
  }
  const endRow = () => {
    endCell()
    if (row.some((c) => c.trim() !== '')) records.push(row)
    row = []
  }

  for (let i = 0; i < text.length; i++) {
    const ch = text[i]
    if (quoted) {
      if (ch !== '"') cell += ch
      else if (text[i + 1] === '"') {
        cell += '"'
        i += 1
      } else quoted = false
    } else if (ch === '"' && cell === '') quoted = true
    else if (ch === delimiter) endCell()
    else if (ch === '\n') endRow()
    else if (ch !== '\r') cell += ch
  }
  if (cell !== '' || row.length > 0) endRow()

  const [first = [], ...rest] = records
  const headers = first.map((h) => h.trim())
  return { headers, rows: rest.map((r) => headers.map((_, i) => r[i] ?? '')) }
}
